import React, { Fragment } from 'react';
import { bool, func, node, number, oneOfType, string } from 'prop-types';
import { noop } from '@ajaibid/utils';

import { Icon } from '../Icon';
import { Text } from '../Text';
import styles from './style';

import stylesGlobal from '../../screens/style';

const ButtonTextIcon = (props) => {
  const {
    onClick,
    src,
    sizeIcon,
    colorIcon,
    text,
    color,
    textColor,
    textSize,
    position,
    marginRight,
    marginLeft,
    hoverColor,
    hoverTextColor,
    children,
    borderColor,
    width,
    onMouseEnter,
    active,
    flexStart,
    onMouseLeave,
    isSVG,
    size,
  } = props;

  const buttonStyles = { ...styles.button, outline: 'none' };
  if (color) {
    buttonStyles.backgroundColor = color;
  }
  if (borderColor) {
    buttonStyles.border = `solid 1px ${borderColor}`;
  }
  if (textColor) {
    buttonStyles.color = textColor;
  }
  if (width) {
    buttonStyles.width = width;
  }
  if (flexStart) {
    buttonStyles.justifyContent = 'flex-start';
  }
  if (size === 'small') {
    buttonStyles.padding = '2px 4px';
  }

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={
        active
          ? {
              ...buttonStyles,
              backgroundColor: hoverColor || '#efefef'
            }
          : buttonStyles
      }
    >
      <div
        style={
          flexStart
            ? {
                alignItems: 'center',
                display: 'flex'
              }
            : {
              ...stylesGlobal.center,
              padding: '0 6px'
            }
        }
      >
        <Fragment>
          {position === 'right' && (
            <Text
              text={text || children}
              color={active ? hoverTextColor : textColor}
              size={textSize}
              marginRight={marginRight}
            />
          )}
          {isSVG ? src : <Icon src={src} size={sizeIcon} color={colorIcon} />}
          {position !== 'rigth' && (
            <Text
              text={text || children}
              color={active ? hoverTextColor : textColor}
              size={textSize}
              marginLeft={marginLeft}
            />
          )}
        </Fragment>
      </div>
    </button>
  );
};

ButtonTextIcon.propTypes = {
  onClick: func,
  sizeIcon: number,
  src: oneOfType([node, string]),
  colorIcon: string,
  text: string,
  color: string,
  textColor: string,
  textSize: number,
  position: string,
  marginRight: number,
  marginLeft: number,
  hoverColor: string,
  hoverTextColor: string,
  children: oneOfType([node, string]),
  borderColor: string,
  width: string,
  onMouseEnter: func,
  active: bool,
  flexStart: string,
  onMouseLeave: func,
  isSVG: bool,
  size: string,
};
ButtonTextIcon.defaultProps = {
  onClick: noop,
  src: '',
  sizeIcon: 0,
  colorIcon: '',
  text: '',
  color: '',
  textColor: '',
  textSize: 0,
  position: '',
  marginRight: 0,
  marginLeft: 0,
  hoverColor: '',
  hoverTextColor: '',
  children: null,
  borderColor: '',
  width: '',
  onMouseEnter: noop,
  active: false,
  flexStart: '',
  onMouseLeave: noop,
  isSVG: false,
  size: '',
};

export default ButtonTextIcon;
